import { gameDay } from "./gameDay";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BACKEND_BASE from './config';
import { getTeamLogoUrl, parseMatchupTeams } from './teamLogos';
import './HomeWeeklyPredictions.css';

export function audience(value) {
  const match = String(value || '').match(/^\s*([\d,.]+)\s*([MK])/i);
  return match ? Number(match[1].replace(/,/g, '')) * (match[2].toUpperCase() === 'M' ? 1e6 : 1e3) : null;
}
const viewers = value => Number.isFinite(value) ? `${(value / 1e6).toFixed(2)}M` : '—';
const percent = value => Number.isFinite(value) ? `${value.toFixed(1)}%` : '—';

export default function HomeWeeklyPredictions() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    fetch(`${BACKEND_BASE}/weekly-predictions`).then(r => {
      if (r.ok === false) throw new Error('Request failed');
      return r.json();
    }).then(value => {
      if (value.error) throw new Error(value.error);
      if (active) setData(value);
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, []);
  const week = [...(data?.weeks || [])].sort((a,b) => Number(b.year) - Number(a.year) || Number(b.week) - Number(a.week))[0];
  const games = (week?.games || []).map(g => ({ ...g, audience: audience(g.revised_predicted || g.predicted) })).filter(g => g.audience !== null).sort((a,b) => b.audience - a.audience);
  const stats = data?.metrics?.pregame;
  const average = games.length ? games.reduce((sum,g) => sum + g.audience, 0) / games.length : null;
  return <section className="home-weekly" aria-labelledby="home-weekly-title">
    <header className="home-weekly-heading">
      <div><p className="home-kicker">{week ? `${week.year} · Week ${week.week}` : 'College football'}</p><h2 id="home-weekly-title">Weekly viewership predictions</h2><p>Projected audiences for the published weekly slate.</p></div>
      <Link to="/weekly" className="btn-primary">View all predictions</Link>
    </header>
    {!data ? <p className="home-weekly-message" role={error ? 'alert' : 'status'}>{error ? 'Weekly predictions are temporarily unavailable.' : 'Loading weekly predictions…'}</p> : !games.length ? <p className="home-weekly-message">No weekly predictions published yet.</p> : <>
      <div className="home-weekly-stats" aria-label="Weekly slate overview">
        <div><span>Games this week</span><strong>{games.length}</strong></div>
        <div><span>Average forecast</span><strong>{viewers(average)}</strong></div>
        <div><span>Largest forecast</span><strong>{viewers(games[0].audience)}</strong></div>
      </div>
      <div className="home-weekly-games" aria-label="Highest predicted audiences">{games.slice(0,3).map((g,i) => <Link to="/weekly" key={g.cfbd_game_id || g.matchup} className="home-weekly-game">
        <div className="home-weekly-game-meta"><span>#{i+1} projected audience</span><span>{g.network}</span></div>
        <div className="home-weekly-teams">{parseMatchupTeams(g.matchup).map((team,j) => <div key={`${team}-${j}`}><img src={getTeamLogoUrl(team)} alt="" loading="lazy"/><span>{team}</span></div>)}</div>
        <div className="home-weekly-game-footer"><strong>{viewers(g.audience)}</strong><span>{gameDay(g.date, week.year)} · {g.date}<br/>{g.time_slot}</span></div>
        {g.x_projection && <small className="home-weekly-provisional">Provisional X</small>}
      </Link>)}</div>
      {stats && <div className="home-weekly-accuracy" aria-label="Overall pregame accuracy"><div><strong>Overall pregame accuracy</strong><span>Scored public predictions · All weeks</span></div><div><strong>{percent(stats.median_error)}</strong><span>Median error</span></div><div><strong>{percent(stats.mean_error)}</strong><span>Mean error</span></div><div><strong>{percent(stats.pct_within_25)}</strong><span>Within 25%</span></div></div>}
    </>}
  </section>;
}
